<template>
    <div class="login-container">
			<div class="login-info" :style="pageHeight">
				<div class="login-info-item logo">
					<img src="../assets/logo.png" alt="击乐星空LOGO" class="logo-img">
					<span>击乐星空管理平台</span>
				</div>
				<div class="login-info-item">
					<input type="text" class="user-name" placeholder="请输入用户名" v-model="userInfo.username" maxlength="20">
				</div>
				<div class="login-info-item">
					<input type="password" class="user-password" placeholder="请输入密码" v-model="userInfo.passwd" maxlength="30">
				</div>
				<div class="error" v-text="errorMsg"></div>
				<div class="login-info-item">
					<div class="login-btn theme-btn" @click="login">登&nbsp;&nbsp;录</div>
				</div>
			</div>
			<div class="login-png" :style="pageHeight"></div>
			<div class="bottom-bei-an">
				<!-- <span class="bei-an" @click="checkBeiAn">沪ICP备16019268号-4</span> -->
				<a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备16019268号-4</a>
			</div>
    </div>
</template>

<script>
    export default {
        name: "Page_Login",
        data() {
            return {
                userInfo: {
                    "username": "",
                    "passwd": ""
                },
                errorMsg: '',

                //   页面高度
                pageHeight: {
                    height: ''
                }
            }
        },
        created() {
            // this.pageHeight.height= window.screen.height+"px";
            // this.pageHeight.height= document.body.clientHeight +"px";
            this.pageHeight.height = document.documentElement.clientHeight + "px";
            // alert(this.pageHeight.height)
        },
        mounted() {
            let self = this
            document.onkeydown = function (e) {
                let ev = document.all ? window.event : e
                if (ev.keyCode === 13) {
                    self.login()
                }
            }
        },
        methods: {
            login() {

                console.log(this.userInfo);
                if (this.userInfo.username === '') {
                    return this.$message.error('用户名不能为空！')
                }
                if (this.userInfo.passwd === '') {
                    return this.$message.error('登录密码不能为空！')
                }
                this.$api.post('/user/login.json', this.userInfo)
                    .then(res => { // 成功才会有数据
                        localStorage['associationToken'] = res.data.token;
                        localStorage['associationProfile'] = JSON.stringify(res.data.profile);
                        this.tools.pageRedirected('page_manage', '/page_manage')
                    }, err => {
                        this.$message.error(err.msg)
                    }).catch(err => {
                    this.$message.error('登录异常！')
                });
            },
            // 密码校验
            passwordChange() {
                // var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; 数字  字母  少了符号  @change = 'passwordChange'
                let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/;
                if (!reg.test(this.userInfo.user_password)) {
                    this.errorMsg = '密码6位以上，由字母、数字、符号,至少两项组合而成。';
                    console.log(this.userInfo.user_password);
                } else {
                    this.errorMsg = ''
                }
            },

        //    查看备案
            checkBeiAn(){
                window.open('https://beian.miit.gov.cn', '_blank');
            }
        },

    }
</script>


<style scoped>
    .login-container {
        width: 100%;
        display: flex;
        padding-left: 100px;
        /*justify-content: center;*/
    }

    .login-info {
        width: 500px;
        height: 100%;
        margin-top: -50px;
        /*border: #888 1px solid;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .login-info-item {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        border-radius: 30px;
        margin-bottom: 20px;
    }

    .user-name, .user-password {
        border: #f3cd04 1px solid;
        border-radius: 30px;
        outline: none;
    }


    .logo {
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: inherit;
    }

    .logo-img {
        display: inline-block;
        width: 180px;
        height: 180px;
        /*border: #888 1px solid;*/
    }

    .logo > span {
        height: 50px;
        /*width: 100%;*/
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        font-weight: bold;
        /*border: #888 1px solid;*/
        margin-left: 20px;
    }

    .login-info-item > input, .login-btn {
        /*display: inline-block;*/
        width: 100%;
        height: 100%;
        font-size: 18px;
        /*padding-left: 10px;*/
        text-align: center;
        /*border: 0;*/
    }

    .login-btn {
        border: #888 1px solid;
        border-radius: 30px;
        line-height: 60px;
        cursor: pointer;
        /*text-decoration: underline #ff231c;*/
    }

    /*校验提示*/
    .error {
        width: 100%;
        text-align: center;
        margin-bottom: 10px;
        color: #FF1111;
    }

    .login-png {
        flex: 1;
        /*border: #dbdbdb 1px solid;*/
        background: url("../assets/login.png") no-repeat;
        background-size: 100% 100%;
    }


    /*    底部备案*/
    .bottom-bei-an {
        position: fixed;
        width: 100%;
        height: 50px;
        background-color: rgba(255,255,255,0.2);
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 100px;
    }
    .bei-an{
        cursor:pointer
    }

</style>



// WEBPACK FOOTER //
// src/pages/Page_Login.vue